// extracted by mini-css-extract-plugin
module.exports = {"head":"projects-module--head--1JA9p","para":"projects-module--para--30tdw","div":"projects-module--div--3qyZ7"};